'use strict';

exports.__esModule = true;

var _webUtils = require('@vezeeta/web-utils');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var signIn = function signIn(token) {
  var expireDate = (0, _webUtils.addDaysToDate)((0, _webUtils.decodeJwtToken)(token).payLoad.exp, parseInt(process.env.REACT_APP_SSO_COOKIE_EXPIRY_DATE));
  var expireDateDays = (0, _webUtils.getNumberOfDaysBetweenTwoDates)(new Date(), expireDate);
  var returnUrl = _webUtils.Cookie.get(_webUtils.Cookie.RETURN_URL);

  _webUtils.Cookie.remove(_webUtils.Cookie.RETURN_URL);
  // Cookie.set(Cookie.AUTH_TOKEN, token, {
  //   expires: expireDateDays,
  // });

  _jsCookie2.default.set('VZT_TOKEN', token, {
    expires: expireDateDays,
    secure: process.env.REACT_APP_FORCE_HTTPS === 'true',
    domain: process.env.REACT_APP_TOKEN_DOMAIN
  });

  window.location = returnUrl || process.env.REACT_APP_SCHEDULE_URL;
};

exports.default = signIn;
module.exports = exports['default'];